import dataLayer from './dataLayer'


function avatarMenuClick (text) {
  dataLayer.add({
    event : 'topNavigationKonto',
    target : text
  })
}

function menuClick (isHamburger, text) {
  const event = isHamburger ? 'topNavigationHamburgarLink' : 'topNavigation'
  const eventAction = isHamburger ? 'hamburgarLink' : 'link'
  dataLayer.add({
    event : event,
    eventAction: eventAction,
    target : text
  })
}
function onOpenHamburgarMenu () {
  dataLayer.add({
    event : 'topNavigationHamburgarMenuOpen',
    eventAction: 'Open'
  })
}

function topNavLayout (size) {
  dataLayer.add({
    topNavLayout : size
  })
}

function logoClick () {
  dataLayer.add({
    event : 'topNavigation',
    eventAction : 'Hem',
    target : 'klickat på logga'
  })
}

function topNavStoreLink (url) {
  dataLayer.add({
    event : 'topNavigationTopLink',
    targetUrl: url
  })
}

function openedSearch () {
  dataLayer.add({
    event: "searchIconClick"
  })
}

export default {
  avatarMenuClick,
  menuClick,
  topNavLayout,
  onOpenHamburgarMenu,
  topNavStoreLink,
  openedSearch,
  logoClick
}
